import { MsalProvider } from '@azure/msal-react';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Outlet, RouterProvider } from 'react-router-dom';
import { initAuthentication, msalClient } from './auth';
import { queryClient } from './queryClient';
import { createRouter } from './router';
import { SignalRProvider } from './signalr/SignalRContext';
import theme from './theme';
import './index.css';
import '@fontsource/lato/300.css';
import '@fontsource/lato/400.css';
import '@fontsource/lato/700.css';
import '../node_modules/react-modal-video/scss/modal-video.scss';
import { isMockApiEnabled } from './utils/mockApi';

const init = async () => {
  await initAuthentication();

  if (isMockApiEnabled()) {
    const { worker } = await import('./mocks/browser');
    await worker.start({ onUnhandledRequest: 'bypass' });
  }

  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <MsalProvider instance={msalClient}>
          <SignalRProvider>
            <QueryClientProvider client={queryClient}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <RouterProvider router={createRouter()} />
                <CssBaseline />
                <Outlet />
              </LocalizationProvider>
            </QueryClientProvider>
          </SignalRProvider>
        </MsalProvider>
      </ThemeProvider>
    </React.StrictMode>,
  );
};

init();
